<template>
  <div class="vehicle-info">
    <ucar-title toApp="123">车辆提报</ucar-title>
    <div
      class="vehicle-info-fail-wrapper"
      v-if="vuexVehicleInfo && vuexVehicleInfo.failReason"
    >
      <p class="vehicle-info-fail-header">驳回原因</p>
      <p class="vehicle-info-fail-content">{{ vuexVehicleInfo.failReason }}</p>
    </div>
    <div class="photo-info">
      <div class="photo-group-title">行驶证</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.carLicense"
          v-model="photoInfo.vehicleLicenseImgUrl"
          @uploadFinish="autoInputVehicleLicense"
          :error="photoError.carLicense"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.carSecondLicense"
          v-model="photoInfo.vehicleLicenseCopyImgUrl"
          @uploadFinish="autoSetCarInfo"
        ></ucar-upload-img>
        <ucar-upload-img
          v-if="serviceCityId === '1'"
          v-bind="photoBaseData.electronicCertificate"
          v-model="photoInfo.electronicVehicleLicenseUrl"
          @uploadFinish="autoSetCarInfo"
        ></ucar-upload-img>
      </div>
      <div class="photo-group-title">车辆</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.car"
          v-model="photoInfo.vehicleUrl"
          @uploadFinish="autoSetCarInfo"
        ></ucar-upload-img>
        <!-- <ucar-upload-img
          v-bind="photoBaseData.carVin"
          v-model="photoInfo.vehicleFrameUrl"
        ></ucar-upload-img> -->
      </div>
      <template v-if="this.info.haveNetworkLicense === 1">
        <div class="photo-group-title">网络预约出租汽车运输证</div>
        <div class="photo-group">
          <ucar-upload-img
            v-bind="photoBaseData.networkCarTransportLiscense"
            v-model="photoInfo.onLineVehicleLicenseUrl"
            @uploadFinish="autoSetCarInfo"
          ></ucar-upload-img>
        </div>
      </template>
    </div>
    <!-- <ucar-section title="以下为自动识别图片的结果，如不正确请修改" v-if="ocrComplete">
      <div class="row row-info">
        <label>车牌号</label>
        <ucar-select
          class="car-info-region"
          :options="baseData.licencePlates"
          placeholder
          v-model="info.region"
        ></ucar-select>
        <input placeholder="请输入" v-model="info.licenceNum" maxlength="7" class="licenceNum">
      </div>
      <div class="row row-info">
        <label>车辆所有人</label>
        <dynamic-textarea v-model="info.vehicleLicenseOwner" :maxlength="30" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row row-info">
        <label>车辆注册日期</label>
        <ucar-date-select
          v-model="info.vehicleLicenseRegisterDate"
          :start-date="new Date((new Date()).getFullYear() - 10, (new Date()).getMonth(), (new Date()).getDate())"
          :end-date="new Date()"
          ></ucar-date-select>
      </div>
      <div class="row row-info">
        <label>车辆识别号</label>
        <input placeholder="请输入" v-model="info.vehicleLicenseVin" maxlength="17">
      </div>
    </ucar-section> -->
    <ucar-section>
      <!-- <div class="row" v-if="needNetworkCarLicense !== 1">
        <label class="lang">是否有网约车运输证</label>
        <ucar-select
          :options="networkLicenseOptions"
          placeholder="请选择"
          :disabled="needNetworkCarLicense === 1"
          v-model="info.haveNetworkLicense"
        ></ucar-select>
      </div> -->
      <template v-if="this.info.haveNetworkLicense === 1">
        <!-- <div class="row">
          <label class="middle">网约车运输证证件号</label>
          <dynamic-textarea v-model="info.onLineVehicleLicenseNo" :maxlength="40" placeholder="请输入"></dynamic-textarea>
        </div> -->
        <div class="row">
          <label>运输证有效期</label>
          <ucar-date-select v-model="info.onLineVehicleLicenseValidDate"
            @input="autoSetOnlineCarDate"
            :start-date="new Date()"
            :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"
            ></ucar-date-select>
        </div>
      </template>
      <div class="row">
        <label>车型</label>
        <ucar-car-select
          placeholder="请选择"
          v-model="info.carModel"
          @input="autoSetCarModel"
        ></ucar-car-select>
      </div>
      <div class="row">
        <label>年检到期日</label>
        <ucar-date-select
          v-model="info.vehicleLicenseAnnualInspectionDate"
          @input="autoSetDate"
          :start-date="new Date()"
          :end-date="
            new Date(
              new Date().getFullYear() + 10,
              new Date().getMonth(),
              new Date().getDate()
            )
          "
        ></ucar-date-select>
      </div>
      <template v-if="serviceCityId === '1'">
        <div class="lease-row">
          <label>车辆轴距(毫米)</label>
          <div>
            <input
              type="number"
              placeholder="请输入"
              v-model="info.wheelbase"
              @blur="validateInput"
              min="2000"
            />
            <p v-if="showError" style="color: red;font-size: 0.9em;text-align: right">*轴距为正整数且不小于2000</p>
          </div>
        </div>

        <div class="row">
          <label>车辆来源</label>
          <ucar-select :options="vehicleSourceOptions"
                       placeholder="请选择"
                       v-model="info.vehicleSource"
                       @input="selectVehicleSource"
          ></ucar-select>
        </div>
        <template v-if="info.vehicleSource === 3">
          <div class="row">
            <label>租赁公司</label>
            <dynamic-textarea placeholder="请输入"
                              v-model="info.leasingCompany"
                              :maxlength="100"
            >
            </dynamic-textarea>
          </div>
          <div class="row">
            <label>租赁开始日期</label>
            <ucar-date-select
              v-model="info.leaseStartDate"
              :start-date="new Date(
              new Date().getFullYear() - 1,
              new Date().getMonth(),
              new Date().getDate()
            )"
              :end-date="
            new Date(
              new Date().getFullYear() + 50,
              new Date().getMonth(),
              new Date().getDate()
            )
          "
            ></ucar-date-select>
          </div>
          <div class="row">
            <label>租赁结束日期</label>
            <ucar-date-select
              v-model="info.leaseEndDate"
              :start-date="new Date()"
              :end-date="
            new Date(
              new Date().getFullYear() + 50,
              new Date().getMonth(),
              new Date().getDate()
            )
          "
            ></ucar-date-select>
          </div>
        </template>
        <template v-if="info.vehicleSource === 2 || info.vehicleSource === 3">
          <div class="lease-row">
            <label>租赁合同/借用说明</label>
            <span class="tips">图片格式文件</span>
            <label class="upload-label" for="file-input">
              <span>{{uploadText}}</span>
            </label>
            <input
              id="file-input"
              type="file"
              class="hidden"
              @change="handleFileSelection"
            />
          </div>
        </template>
      </template>
    </ucar-section>
    <!-- <ucar-section title="以下为自动识别图片的结果，如不正确请修改" v-if="rejectedCount >= 3">
      <div class="row">
        <label>车牌号</label>
        <ucar-select
          class="car-info-region"
          :options="baseData.licencePlates"
          placeholder
          v-model="info.region"
        ></ucar-select>
        <input placeholder="请输入" v-model="info.licenceNum" maxlength="7">
      </div>
      <div class="row">
        <label>车辆所有人</label>
        <dynamic-textarea v-model="info.vehicleLicenseOwner" :maxlength="30" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row">
        <label>车辆注册日期</label>
        <ucar-date-select
          v-model="info.vehicleLicenseRegisterDate"
          :start-date="new Date((new Date()).getFullYear() - 10, (new Date()).getMonth(), (new Date()).getDate())"
          :end-date="new Date()"
          ></ucar-date-select>
      </div>
      <div class="row">
        <label>车辆识别号</label>
        <input placeholder="请输入" v-model="info.vehicleLicenseVin" maxlength="17">
      </div>
    </ucar-section> -->

    <div class="footer">
      <button
        type="button"
        class="btn-submit app-btn-submit"
        :class="{ 'app-btn-submit-enable': enableSubmit }"
        @click="submit"
      >
        提交
      </button>
    </div>
    <error-dialog
      v-if="showErrorDialog"
      @close="closeErrorDialog"
      :groups="rejectErrors"
    ></error-dialog>
    <vehicle-tips
      v-if="showTips"
      :list="carRequire"
      @hide="showTips = false"
    ></vehicle-tips>
  </div>
</template>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';

.vehicle-info-fail-wrapper {
  margin-bottom: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  padding: 30px;

  .vehicle-info-fail-header {
    font-size: $ucar_font_h4;
    line-height: 1;
    margin-bottom: 20px;
  }

  .vehicle-info-fail-content {
    color: $ucar_label_color;
    font-size: $ucar_font_h5;
    line-height: 1.5;
  }
}

.vehicle-info .row .licenceNum {
  width: 60px;
}

.photo-info {
  margin-top: 88px;
}
.lease-row {
  background-color: #fff;
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1PX solid $ucar_light_border; /*no*/

  label {
    height: 100px;
    line-height: 100px;
    display: inline-block;
    padding-right: 10px;
    color: $ucar_font_color;
    font-size: $ucar_font_h4;
  }
  input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    display: inline-block;
    font-size: $ucar_font_h4;
    text-align: right;
    line-height: 1.6;
    background-color: transparent;
    padding: 24px 40px 24px 20px;
  }
  .tips{
    height: 100px;
    line-height: 100px;
    display: inline-block;
    padding-right: 20px;
    color: $ucar_font_assist_color;
    font-size: $ucar_font_min;
  }
  .hidden {
    display: none;
  }
  .upload-label {
    display: inline-block;
    cursor: pointer;
    color: #409EFF;
    font-size: $ucar_font_h5;
  }
}
</style>

<script>
import carSelect from '../../components/car-select'
import VehicleTips from '../../components/vehicle-tips'
import DynamicTextarea from '../../components/dynamic-textarea'
import ErrorDialog from '../../components/error-dialog'
import UcarDate from 'ucar-date'
import valid from '../../utils/valid-check'
import preload from '../../utils/preload'
import ucarStorage from '../../utils/storage.js'
import { copyTargetProperty, compareTargetProperty } from '../../utils/transform'
import { PhotoBaseData, licencePlates, resetVehicleLicense, colors } from '../../utils/constants'
import { validateNewVehicleInfo, readVehicleLicense, submitNewVehicleInfo, getNewRecruitProgress, getVehicleInfo, getCityConfig, getVehicleDict, getDriverConfig, getEnlist } from '../../api'
import { popView } from "../../utils/jsBridge/jsBridge.js";
import { uploadFileHelper } from '@/utils/uploadfile'

export default {
  data() {
    return {
      rejectedCount: 0,
      showTips: false,
      showRejectInfo: false,
      showErrorDialog: false,
      rejectErrors: [],
      vehicleLicenseOcrInfo: {
        ...resetVehicleLicense
      },
      info: {
        vehicleLicenseOwner: '', // 车辆所有人
        vehicleLicenseVehicleType: '', // 行驶证车辆类型
        region: '京',
        vehicleLicenseRegisterDate: '', // 车辆注册日期
        vehicleLicenseAddress: '', // 行驶证地址
        vehicleLicenseUseCharacter: '', // 车辆使用性质
        vehicleLicenseIssueDate: '', // 行驶证发证日期
        vehicleLicensePlateNo: '',
        vehicleLicenseOcr: 1,
        licenceNum: '',
        carModel: '',
        vehicleLicenseVin: '',
        vehicleLicenseEngineNo: '', // 车辆发动机号
        haveNetworkLicense: '',
        onLineVehicleLicenseNo: '', // 网约车运输证号
        onLineVehicleLicenseValidDate: (new UcarDate()).dateStr, // 网约车运输证有效期
        vehicleLicenseAnnualInspectionDate: '',
        wheelbase: '', // 车辆轴距
        vehicleSource: '', // 车辆来源
        leasingCompany: '', // 租赁公司
        leaseStartDate: '', // 租赁开始日期
        leaseEndDate: '', // 租赁结束日期
      },
      photoInfo: {
        vehicleLicenseImgUrl: '',
        vehicleLicenseCopyImgUrl: '',
        vehicleUrl: '',
        vehicleFrameUrl: '',
        onLineVehicleLicenseUrl: '',
        electronicVehicleLicenseUrl: '',
        leaseContractUrl: '',
      },
      photoError: {
        carLicense: ''
      },
      photoBaseData: PhotoBaseData,
      baseData: {
        licencePlates: licencePlates
      },
      enlistId: '',
      carRequire: [],
      vehicleSourceOptions: [
        {name: '自有', value: 1},
        {name: '借用', value: 2},
        {name: '租赁', value: 3},
      ],
      serviceCityId:'',
      showError:false,
    }
  },
  computed: {
    uploadText(){
      if(valid.notEmptyBool(this.photoInfo.leaseContractUrl)){
        return '修改'
      }else{
        return '上传'
      }
    },
    ocrComplete() {
      return this.info.licenceNum || this.info.vehicleLicenseOwner || this.info.vehicleLicenseVin
    },
    // needNetworkCarLicense() {
    //   return this.vuexCompanyId ? this.vuexCurrentCity.needCompanyNetworkCarLicense : this.vuexCurrentCity.needNetworkCarLicense
    // },
    // networkLicenseOptions() {
    //   return this.needNetworkCarLicense === 1 ? [{ name: '是', value: 1 }] : [
    //     {
    //       name: '是',
    //       value: 1
    //     },
    //     {
    //       name: '否',
    //       value: 0
    //     }
    //   ]
    // },
    enableSubmit() {
      let errorInfo =
        valid.notEmpty(this.info.vehicleLicenseOwner, '车辆所有人姓名') ||
        valid.notEmpty(this.photoInfo.vehicleLicenseImgUrl, '行驶证正本') ||
        valid.notEmpty(this.photoInfo.vehicleLicenseCopyImgUrl, '行驶证副本') ||
        valid.notEmpty(this.photoInfo.vehicleUrl, '全车照片') ||
        // valid.notEmpty(this.photoInfo.vehicleFrameUrl, '车架号照片') ||
        (this.info.haveNetworkLicense === 1 &&
        valid.notEmpty(this.photoInfo.onLineVehicleLicenseUrl, '网约车运输证')) ||
        // (this.info.haveNetworkLicense === 1 &&
        // valid.notEmpty(this.info.onLineVehicleLicenseNo, '网约车运输证证件号')) ||
        (this.info.haveNetworkLicense === 1 &&
        valid.notEmpty(this.info.onLineVehicleLicenseValidDate, '运输证有效期')) ||
        // valid.notEmpty(this.info.vehicleLicenseRegisterDate, '车辆注册日期') ||
        // valid.notEmpty(this.info.vehicleLicenseVin, '车辆识别号') ||
        valid.notEmpty(this.info.vehicleLicenseAnnualInspectionDate, '年检到期日') ||
        valid.notEmpty(this.info.carModel, '车型')
      // || valid.notEmpty(this.info.licenceNum, '车牌号')
      if(this.serviceCityId === '1'){
        errorInfo = valid.notEmpty(this.photoInfo.electronicVehicleLicenseUrl,'电子行驶证') ||
          valid.vehicleWheelbase(this.info.wheelbase,'请输入轴距为正整数且不小于2000') ||
          valid.notEmpty(this.info.vehicleSource, '车辆来源') || errorInfo
        if(this.info.vehicleSource === 3){
          errorInfo = valid.notEmpty(this.info.leasingCompany, '租赁公司') ||
            valid.notEmpty(this.info.leaseStartDate, '租赁开始日期') ||
            valid.notEmpty(this.info.leaseEndDate, '租赁结束日期') || errorInfo
        }
        if(this.info.vehicleSource === 2 || this.info.vehicleSource === 3){
          errorInfo = valid.notEmpty(this.photoInfo.leaseContractUrl, '租赁合同') || errorInfo
        }
      }
      return errorInfo === ''
    }
  },
  components: {
    'ucar-car-select': carSelect,
    ErrorDialog,
    DynamicTextarea,
    VehicleTips
  },
  methods: {
    validateInput() {
      this.showError = !/^(2000|[2-9]\d{3,}|[1-9]\d{4,})$/g.test(this.info.wheelbase)
    },
    async handleFileSelection(event) {
      console.log(event);
      const files = Array.from(event.target.files);
      if(files === null || files.length === 0){
        this.$alert('选择文件失败，请重新选择')
        return
      }
      const selectFile = files[0];
      await uploadFileHelper(selectFile, {
        allowedTypes: ['image/jpeg', 'image/jpg', 'image/png'],
        // allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
        typeTips: '请上传jpg、jpeg、png格式的文件',
        maxSize: 10 * 1024 * 1024, // 10MB
        onLoading: (isLoading) => {
          isLoading ? this.$loading.show() : this.$loading.hidden();
        },
        onSuccess: (url) => {
          console.log('文件上传成功:', url);
          // 处理上传成功的逻辑
          this.photoInfo.leaseContractUrl = url
        },
        onError: (message, error) => {
          console.error('上传错误:', error);
          this.$alert(message)
        }
      });
    },
    readCarStore() {
      if (ucarStorage.getStorage('carPhotoInfo')) {
        this.photoInfo = ucarStorage.getStorage('carPhotoInfo')
      }
      if (ucarStorage.getStorage('carInfo')) {
        this.info = ucarStorage.getStorage('carInfo')
        console.log(this.info);
      }

    },
    async getBaseData() {
      this.$loading.show()
      const { serviceCityId, identityFlag } = this.$route.query
      const res = await getVehicleInfo({ enlistId: this.enlistId })
      this.info.vehicleSource = res.vehicleSourceBeijing
      // 获取运输证配置信息
      const result = await getDriverConfig({ serviceCityId, identityFlag })
      // 获取该司机是企业还是个人
      const enlistRes = await getEnlist({ enlistId: this.enlistId })
      const channel = enlistRes.channel
      // 招募渠道是1代表是个人
      this.info.haveNetworkLicense = channel === 1 ? result.transportCertificate : result.companyTransportCertificate
      if (res.status === 3) {
        this.$alert({
          type: 'confirm',
          content: '信息审核未通过',
          dsc: res.reason,
          okText: '重新上传',
          center: true
        })
      }
      // const resa = await getNewRecruitProgress({ enlistId: this.enlistId })
      if (res.status === 0 || res.status === 5) {
        // let serviceCityId = 18
        // let identityFlag = '1'
        const requireRes = await getCityConfig({ serviceCityId })
        // 根据城市配置是否开启舒享而显示舒享/专车需求，不是身份了
        this.carRequire = requireRes.enableComfort===0?requireRes.vehicleRequire.split('\n').filter(item => !!item.replace(/\s/g, '')):requireRes.comfortVehicleRequire.split('\n').filter(item => !!item.replace(/\s/g, '')),
        this.showTips = true
      }
      preload([
        PhotoBaseData.carLicense.defaultImg,
        PhotoBaseData.carSecondLicense.defaultImg,
        PhotoBaseData.electronicCertificate.defaultImg,
        PhotoBaseData.car.defaultImg,
        PhotoBaseData.carVin.defaultImg,
        PhotoBaseData.networkCarLicense.defaultImg
      ]).then(() => {
        if (this.vuexVehicleInfo) {
          copyTargetProperty(this.info, this.vuexVehicleInfo)
          copyTargetProperty(this.photoInfo, this.vuexVehicleInfo)
          this.rejectedCount = this.vuexVehicleInfo.vehicleRejectedCount
          const region = this.baseData.licencePlates.find(item => item.name === this.vuexVehicleInfo.vehicleLicensePlateNo[0])
          this.info.region = region.value || ''
          this.info.licenceNum = this.vuexVehicleInfo.vehicleLicensePlateNo.substr(1, this.vuexVehicleInfo.vehicleLicensePlateNo.length - 1)
          // 如果是从缓存中读取，需要对当前缓存中的信息做判断如果上次提交的OCR识别结果为完成，则需将当前缓存的提交信息反向映射为OCR行驶证缓存信息，以便在提交时完成对比
          if (this.vuexVehicleInfo.vehicleLicenseOcr === 1) copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
        } else if (res) {
          copyTargetProperty(this.info, res)
          copyTargetProperty(this.photoInfo, res)
          const region = this.baseData.licencePlates.find(item => item.name === res.vehicleLicensePlateNo[0])
          this.info.region = region.value || ''
          this.info.licenceNum = res.vehicleLicensePlateNo.substr(1, res.vehicleLicensePlateNo.length - 1)
          // this.info.carModel = { carIdent:res.brand, colorId: res.colorId, modelId: res.modelId }
          if (res.brand) {
            getVehicleDict()
              .then(re => {
                const tempCarModel = {}
                tempCarModel.currentBrand = re.filter(item => {
                  return res.brand === item.carIdent
                })[0]
                const modelList = tempCarModel.currentBrand.vehicleModeList
                tempCarModel.currentModel = modelList.filter(item => {
                  return res.modelId === item.id
                })[0]
                tempCarModel.currentColor = colors.filter(item => {
                  return res.colorId === item.id
                })[0]
                tempCarModel.name = `${tempCarModel.currentBrand.carIdent} ${tempCarModel.currentModel.carName} ${tempCarModel.currentColor.name}`
                this.info.carModel = { ...tempCarModel }
              })
              .catch(({ data }) => {
                this.$alert(data.msg)
              })
          }
          if (res.vehicleLicenseOcr === 1) copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
        }
        this.$loading.hidden()
      })
    },
    async autoInputVehicleLicense(val) {
      this.$loading.show('正在识别图片信息')
      try {
        this.trackEvent('司招-行驶证正面上传', 'success')
        const res = await readVehicleLicense({
          enlistId: this.enlistId,
          vehicleLicenseImgUrl: val
        })
        this.$loading.hidden()
        if (!res.vehicleLicenseEngineNo && !res.vehicleLicensePlateNo) {
          // 识别失败，重置行驶证信息
          this.info = { ...this.info, ...resetVehicleLicense }
          // 重置缓存中的行驶证OCR信息
          copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
          this.photoError.carLicense = '未识别到行驶证正面信息，请重新上传'
          this.trackEvent('司招-行驶证正面识别失败', 'error')
          return
        }
        this.info = { ...this.info, ...res }
        if (res.vehicleLicensePlateNo) {
          const region = this.baseData.licencePlates.find(item => item.name === res.vehicleLicensePlateNo[0])
          this.info.region = region.value || ''
          this.info.licenceNum = res.vehicleLicensePlateNo.substr(1, res.vehicleLicensePlateNo.length - 1)
        }
        // 缓存识别成功的行驶证OCR信息
        copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
        ucarStorage.setStorage('carPhotoInfo', this.photoInfo)
        ucarStorage.setStorage('carInfo', this.info)
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        // 去除OCR识别错误提示
        this.photoError.carLicense = ''
      } catch (error) {
        // 识别失败，重置行驶证信息
        this.info = { ...this.info, ...resetVehicleLicense }
        // 重置缓存中的行驶证OCR信息
        copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
        this.photoError.carLicense = '未识别到行驶证正面信息，请重新上传'
        this.trackEvent('司招-行驶证正面识别失败', 'error')
      }
    },
    autoSetCarInfo() {
      ucarStorage.setStorage('carPhotoInfo', this.photoInfo)

    },
    autoSetCarModel(val) {
      if (val) {
        ucarStorage.setStorage('carInfo', this.info)
      }
    },
    autoSetDate(val) {
      if (val) {
        ucarStorage.setStorage('carInfo', this.info)
      }
    },
    autoSetOnlineCarDate(val) {
      if (val) {
        ucarStorage.setStorage('carInfo', this.info)
      }
    },
    selectVehicleSource(val) {
      console.log("selectVehicleSource--->",val)
      this.info.leasingCompany = ''
      this.info.leaseStartDate = ''
      this.info.leaseEndDate = ''
      this.photoInfo.leaseContractUrl = ''
    },
    late() {
      this.$router.push('/new-progress-info')
    },
    async submit() {
      try {
        // const errorInfo =
        //   valid.cnName(this.info.vehicleLicenseOwner, '请输入正确的车辆所有人名称') ||
        //   valid.carOwnerLimit(this.info.vehicleLicenseOwner) ||
        //   valid.carNumber(this.info.licenceNum)
        // console.log(errorInfo)
        // if (errorInfo) {
        //   this.$alert(errorInfo)
        //   return
        // }
        const body = {
          ...this.info,
          ...this.photoInfo,
          vehicleLicensePlateNo: `${this.info.region}${this.info.licenceNum}`,
          brand: this.info.carModel.currentBrand.carIdent,
          modelId: Number(this.info.carModel.currentModel.id),
          colorId: Number(this.info.carModel.currentColor.id),
          enlistId: this.enlistId,
        }
        // 如果行驶证相关信息与缓存中的行驶证OCR信息不符则证明用户手动修改过行驶证相关信息
        body.vehicleLicenseOcr = compareTargetProperty(this.vehicleLicenseOcrInfo, body) ? 1 : 0
        delete body.carModel
        this.trackEvent('司招-申请表单车-提交', 'click')
        console.log("body---->",body)
        // 后端校验车辆信息
        const a = await validateNewVehicleInfo(body)
        const submitRes = await submitNewVehicleInfo(body)
        if (submitRes) {
          popView()
        }
      } catch (error) {
        console.warn(error)
      }
    },
    closeErrorDialog() {
      this.showErrorDialog = false
      this.rejectErrors = []
    }
  },
  mounted() {
    const enlistId = this.$route.query.enlistId
    this.serviceCityId = this.$route.query.serviceCityId
    if (enlistId) this.enlistId = enlistId
    this.changeStatusToFillInfo()
    this.getBaseData()
    this.readCarStore()
  }
}
</script>
